import banner02 from '../../../assets/banner02.png';
import { useMutation } from "@tanstack/react-query";
import { useState } from 'react';

const NewsletterSection = () => {
    // const API_URL = import.meta.env.VITE_API_URL;
    // const [form, setForm] = useState({name: "", grade: "", email: "", phone: "", interests: []});
    // const [formErrors, setFormErrors] = useState({name: "", grade: "", email: "", phone: "", interests: ""});
    // const [submitError, setSubmitError] = useState("");
    // const interestOptions = ['수학', '과학', '이야기', '코딩', '역사인물', '미술', '직업', '캐릭터'];

    // const mutation = useMutation({
    //     mutationFn: async (data: {name: string, grade: string, email: string, phone: string, interests: string[]}) => {
    //         const params = new URLSearchParams();
    //         Object.entries(data).forEach(([key, value]) => {
    //             if (Array.isArray(value)) {
    //                 value.forEach(v => params.append(`${key}[]`, v));
    //             } else {
    //                 params.append(key, value);
    //             }
    //         });

    //         const response = await fetch(`${API_URL}/bbs/ajax.apply_newsletter.php`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/x-www-form-urlencoded",
    //             },
    //             body: params,
    //         });

    //         if (!response.ok) throw new Error("네트워크 오류");

    //         return response.json();
    //     },
    //     onSuccess: (response) => {
    //         if(!response.success) {
    //             switch(response.code) {
    //                 case "INVALID_REQUEST":
    //                     setSubmitError("필수 필드값이 입력되지 않았습니다.");
    //                     break;
    //                 default:
    //                     setSubmitError("알 수 없는 오류가 발생했습니다.");
    //                     break;
    //             }
    //             return;
    //         }

    //         setForm({name: "", grade: "", email: "", phone: "", interests: []});
    //         setSubmitError("신청이 완료되었습니다! 곧 연락드리겠습니다.");
    //     },
    //     onError: (error: any) => {
    //         setSubmitError(error.message);
    //     }
    // });

    // const validate = (name: string, value: any) => {
    //     let validValue = value;
    //     let errorMsg = "";

    //     if (name === "name") {
    //         validValue = value.replace(/[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ]/g, "");
    //         if (!validValue.trim()) {
    //             errorMsg = "이름을 입력해주세요.";
    //         }
    //     }

    //     if (name === "grade") {
    //         if (!value.trim()) {
    //             errorMsg = "학년을 입력해주세요.";
    //         }
    //     }

    //     if (name === "email") {
    //         validValue = value.trim();
    //         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //         if (!emailRegex.test(validValue)) {
    //             errorMsg = "올바른 이메일 형식이 아닙니다.";
    //         }
    //     }

    //     if (name === "phone") {
    //         let numbers = value.replace(/[^0-9]/g, "");

    //         if (numbers.length < 4) {
    //             validValue = numbers;
    //         } else if (numbers.length < 8) {
    //             validValue = `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    //         } else {
    //             validValue = `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
    //         }

    //         if (numbers.length < 10) {
    //             errorMsg = "올바른 연락처를 입력해주세요.";
    //         }
    //     }

    //     if (name === "interests") {
    //         if (!value || value.length === 0) {
    //             errorMsg = "관심사를 하나 이상 선택해주세요.";
    //         }
    //     }

    //     return {
    //         value: validValue,
    //         error: errorMsg,
    //     };
    // };

    // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    //     const { name, value, type, checked } = e.target;
    //     let inputValue: any = value;

    //     if (type === "checkbox" && name === "interests") {
    //         let newInterests = [...form.interests];
    //         if (checked) {
    //             if (!newInterests.includes(value)) {
    //                 newInterests.push(value);
    //             }
    //         } else {
    //             newInterests = newInterests.filter((v) => v !== value);
    //         }

    //         inputValue = newInterests;
    //     }

    //     const result = validate(name, inputValue);

    //     setSubmitError("");
    //     setForm((prev) => ({ ...prev, [name]: result.value }));
    //     setFormErrors((prev) => ({ ...prev, [name]: result.error }));
    // };

    // const handleSubmit = () => {
    //     const fields = ["name", "grade", "email", "phone", "interests"];
    //     const newErrors: any = {};
    //     const newForm: any = { ...form };

    //     fields.forEach((field) => {
    //         const result = validate(field, form[field], form);
    //         newErrors[field] = result.error;
    //         newForm[field] = result.value;
    //     });

    //     setFormErrors(newErrors);
        
    //     if (Object.values(newErrors).some((e) => e)) return;

    //     mutation.mutate(newForm);
    // };

    return (
        <section id="contact" className="py-20 bg-gradient-to-br from-purple-600 to-blue-600">
            <div className="max-w-7xl mx-auto px-4">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
                            무료 체험 수업 신청
                        </h2>
                        <p className="text-xl text-purple-100 max-w-3xl mx-auto">
                            아이노우 라이브클래스의 특별한 수업을 먼저 체험해보세요!
                            <br />
                            개인 맞춤형 상담과 함께 최적의 수업을 추천해드립니다.
                        </p>
                    </div>
                    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                        <a 
                            href="http://pf.kakao.com/_xjDIdX" 
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                window.gtag('config', 'AW-18144019506');
                            }}
                        >
                            <img src={banner02} alt=""/>
                        </a>
                    </div>
                    {/*<div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl overflow-hidden">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label
                                    htmlFor="name"
                                    className="block text-sm font-semibold text-gray-700 mb-2"
                                >
                                    학생 이름 *
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={form.name}
                                    disabled={mutation.isPending}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                                    placeholder="학생 이름을 입력해주세요"
                                />
                                {formErrors.name && (
                                    <p className="text-red-500 text-xs mt-1 min-h-[16px]">
                                        {formErrors.name}
                                    </p>
                                )}
                            </div>
                            <div>
                                <label
                                    htmlFor="grade"
                                    className="block text-sm font-semibold text-gray-700 mb-2"
                                >
                                    학년 *
                                </label>
                                <div className="relative">
                                    <select
                                        id="grade"
                                        name="grade"
                                        value={form.grade}
                                        disabled={mutation.isPending}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm appearance-none pr-8"
                                        required
                                    >
                                        <option value="">학년을 선택해주세요</option>
                                        <option value="1">초등 1학년</option>
                                        <option value="2">초등 2학년</option>
                                        <option value="3">초등 3학년</option>
                                        <option value="4">초등 4학년</option>
                                        <option value="5">초등 5학년</option>
                                        <option value="6">초등 6학년</option>
                                    </select>
                                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                </div>
                                {formErrors.grade && (
                                    <p className="text-red-500 text-xs mt-1 min-h-[16px]">
                                        {formErrors.grade}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-semibold text-gray-700 mb-2"
                                >
                                    이메일 *
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={form.email}
                                    disabled={mutation.isPending}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                                    placeholder="example@email.com"
                                    required
                                />
                                {formErrors.email && (
                                    <p className="text-red-500 text-xs mt-1 min-h-[16px]">
                                        {formErrors.email}
                                    </p>
                                )}
                            </div>
                            <div>
                                <label
                                    htmlFor="phone"
                                    className="block text-sm font-semibold text-gray-700 mb-2"
                                >
                                    연락처 *
                                </label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={form.phone}
                                    disabled={mutation.isPending}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                                    placeholder="010-0000-0000"
                                    required
                                />
                                {formErrors.phone && (
                                    <p className="text-red-500 text-xs mt-1 min-h-[16px]">
                                        {formErrors.phone}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="mb-6">
                            <label className="block text-sm font-semibold text-gray-700 mb-3">
                                관심 있는 수업 (복수 선택 가능)
                            </label>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                                {interestOptions.map((interest) => (
                                    <label
                                        key={interest}
                                        className="flex items-center space-x-2 cursor-pointer"
                                    >
                                        <input
                                            type="checkbox"
                                            name="interests"
                                            value={interest}
                                            checked={form.interests.includes(interest)}
                                            onChange={handleChange}
                                            className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                                        />
                                        <span className="text-sm text-gray-700">{interest}</span>
                                    </label>
                                ))}
                            </div>
                            {formErrors.interests && (
                                <p className="text-red-500 text-xs mt-1 min-h-[16px]">
                                    {formErrors.interests}
                                </p>
                            )}
                        </div>
                        {submitError  && (
                            <div
                              className={`mb-6 p-4 rounded-xl ${submitError .includes('완료') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}
                            >
                                {submitError }
                            </div>
                        )}
                        <button
                            onClick={handleSubmit}
                            disabled={mutation.isPending}
                            className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-4 rounded-xl text-lg font-bold hover:from-purple-700 hover:to-blue-700 transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                        >
                            {mutation.isPending ? (
                                <div className="flex items-center justify-center space-x-2">
                                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    <span>신청 중...</span>
                                </div>
                            ) : (
                                <>
                                <i className="ri-send-plane-line mr-2"></i>
                                무료 체험 신청하기
                                </>
                            )}
                        </button>
                        <p className="text-center text-sm text-gray-500 mt-4">
                            신청 후 24시간 내에 전문 상담사가 연락드립니다.
                        </p>
                    </div>*/}
                </div>
            </div>
        </section>
    );
};

export default NewsletterSection;
